export interface IResponseModel<T> {
  httpCode: number;
  message: string;
  response: T;
  status?: string;
}
